import {
  TEE_SHEET_STATUSES as SharedTeeSheetStatuses,
} from "shared/dist/types/TeeSheet";

export type {
  TeeSheet,
  TeeSheetStatus,
  TeeSheetTimingBasis,
} from "shared/dist/types/TeeSheet";

export const TEE_SHEET_STATUSES = SharedTeeSheetStatuses;
